import { motion } from "framer-motion";

export default function RuleCard({ regra, index, testid, accent = "#8B5CF6" }) {
    return (
        <motion.article
            data-testid={testid}
            layout
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.3, delay: Math.min(index * 0.05, 0.35) }}
            className="glass-card glass-card-hover relative overflow-hidden rounded-2xl p-6"
        >
            <span
                className="absolute inset-y-0 left-0 w-1"
                style={{
                    background: `linear-gradient(to bottom, ${accent}, transparent)`,
                }}
            />
            <span
                className="font-code text-[11px] font-semibold uppercase tracking-[0.22em]"
                style={{ color: accent }}
            >
                Regra Nº {regra.numero}
            </span>
            <h3 className="mt-2 font-display text-xl font-bold text-white">
                {regra.titulo}
            </h3>
            <p className="mt-2.5 text-sm leading-relaxed text-gray-400">
                {regra.texto}
            </p>
        </motion.article>
    );
}
